<template>
  <v-dialog
    width="900"
    persistent
    scrollable
    v-model="isOpened"
  >
    <v-form @submit.prevent.native="$canWrite && (save($event))">
      <v-card>
        <v-card-title>
          Clôturer une intervention
          <v-spacer />
          <v-btn icon @click="isOpened = false" v-if="!isSaving">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-12" v-if="!hasIntervention">
          <v-progress-linear
            color="primary"
            indeterminate
            rounded
            height="6"
          ></v-progress-linear>
        </v-card-text>
        <v-card-text class="pa-5" v-else>
          <v-alert
            :value="true"
            type="error"
            class="mb-2"
            v-if="errors.length"
          >
            Veuillez corriger les erreurs suivantes :
            <ul>
              <li v-for="(error, i) in errors" :key="`error${i}`">
                {{ error }}
              </li>
            </ul>
          </v-alert>
          <update-comment v-model="comment" required autofocus class="pa-3" />
        </v-card-text>

        <v-divider />
        <v-card-actions>
          <v-row no-gutters justify="center" align="center" class="px-3">
            <v-spacer />
            <v-btn text @click="isOpened = false" tabindex="-1" class="mr-4" v-if="!isSaving">Annuler</v-btn>
            <v-btn :disabled="!$canWrite" type="submit" :loading="isSaving" color="primary darken-1">Clôturer</v-btn>
          </v-row>
        </v-card-actions>

      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>

import { mapState } from 'vuex';
import _ from 'lodash';
import UpdateComment from './Update/Comment.vue';

export default {
  props: [`intervention`],
  data: () => ({
    isOpened: true,
    isSaving: false,
    errors: [],
    comment: ``,
  }),
  computed: {
    ...mapState(`model/user`, [`me`]),
    hasIntervention() {
      return this.intervention && this.intervention !== null;
    },
  },
  methods: {
    async save() {
      this.errors = [];

      if (_.trim(this.comment) === ``) { this.errors.push(`Veuillez saisir un commentaire`); }

      if (!this.errors.length) {
        this.isSaving = true;
        const step = await this.$store.dispatch(`model/intervention/close`, {
          interventionId: this.intervention.id,
          comment: this.comment,
        });
        this.isSaving = false;
        this.$emit(`added`, step);
      }
    },
  },
  beforeMount() {
    if (this.hasIntervention) {
      this.statusId = this.intervention.status.id;
    }
  },
  watch: {
    isOpened(isOpened) {
      if (!isOpened) {
        this.$emit(`close`);
      }
    },
  },
  components: {
    UpdateComment,
  },
};
</script>

<style lang="scss">
</style>
